var _defs, _path, _path2, _path3, _ellipse, _mask, _g, _g2, _mask2, _g3, _mask3, _g4, _mask4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtDial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 106,
    height: 67,
    viewBox: "0 0 106 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "13kk5kouqa",
    d: "M0.068 0.079L28.488 0.079 28.488 23.464 0.068 23.464z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "mlwxslzz5c",
    d: "M0.106 0.018L80.849 0.018 80.849 40.436 42.227 40.436 0.106 40.436z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "821yqsqhue",
    d: "M0.109 0.006L3.428 0.006 3.428 2.761 0.109 2.761z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "8y41n41zcg",
    d: "M0 0.139L3.181 0.139 3.181 3.638 0 3.638z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "21nixis4li",
    d: "M0.185 0.008L5.831 0.008 5.831 3.67 0.185 3.67z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4m7hpuqqtk",
    d: "M0 0L4.384 0 4.384 4.874 0 4.874z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "8xl91ge1em",
    d: "M0.109 0.005L3.428 0.005 3.428 2.087 0.109 2.087z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1mlzp51vio",
    d: "M0 0L2.455 0 2.455 2.771 0 2.771z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t96m0wff0q",
    d: "M0.109 0.005L3.428 0.005 3.428 2.087 0.109 2.087z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tjopveeqds",
    d: "M0 0L2.455 0 2.455 2.771 0 2.771z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-107 -488) translate(107 488)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EBF6FF",
    d: "M69.075 65.18c31.696-.393 31.696 1.32 35.771-18.293C108.921 27.273 102.481 0 64.885 0S-9.539 24.989 2.232 48.824C14.002 72.66 37.379 65.573 69.075 65.18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17.817 53.569h-4.723c1.732-7.71 3.306-13.14 4.723-16.287 4.497-9.987 11.04-16.694 17.926-19.644 10.14-4.345 16.825-5.574 20.053-3.687l10.798 1.45c9.724 4.023 16.466 8.424 20.226 13.203C90.58 33.383 93 41.79 94.082 53.83l-76.265-.261z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M72.183 35.522L65.751 30.384 58.46 28.128 53.007 28.46 45.744 29.136 40.66 31.825 35.598 35.522 32.548 39.021 30.007 43.303 27.158 49.951 33.355 43.723 38.786 39.039 46.763 37.009 49.67 36.846 54.34 37.217 56.998 37.933 59.503 39.039 62.449 43.212 73.714 37.217z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.103,
    cy: 51.406,
    fill: "#A4C5F2",
    rx: 5.577,
    ry: 5.335
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.579 13.094) translate(.611 .79) translate(32.592 23.666)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "zbz9b4jcwb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#13kk5kouqa"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#E0DFE6",
    d: "M28.478.44c-.022-.237-.216-.409-.463-.35-.753.181-1.455.844-2.016 1.351-.675.61-1.34 1.227-2.036 1.815-1.481 1.252-2.983 2.515-4.415 3.821-1.392 1.27-2.773 2.561-4.085 3.912-.306.315-.657.655-1.009 1.017-.634-1.365-1.64-2.513-3.103-2.816-.779-.162-1.24.689-.748 1.276 1.24 1.478 1.51 2.894.65 4.681-.742 1.546-1.365 2.756-2.862 3.462-.992.468-2.436.587-3.617.005-.697-.343-1.418-.844-1.954-1.405-.542-.568-.886-1.28-1.4-1.869-.259-.295-.84-.228-1.013.13-1.08 2.24.611 5.152 2.398 6.488 2.413 1.805 5.437 1.923 8.135.698 2.334-1.059 3.895-3.087 4.288-5.498 1.367-.658 2.331-2.292 3.287-3.38 1.284-1.46 2.664-2.828 3.973-4.265 1.27-1.394 2.537-2.859 3.639-4.388.883-1.226 2.5-3.082 2.351-4.684",
    style: {
      mixBlendMode: "multiply"
    },
    mask: "url(#zbz9b4jcwb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E0DFE6",
    d: "M42.193 38.62c-.2-.784-1.096-1.285-1.876-1.058-.488.142-.847.372-1.224.706-.097.086-.187.173-.275.27-.046.06-.096.117-.151.17l.072-.047c-.04.043-.095.089-.15.13-.04.02-.093.047-.139.063l-.172.073c-.188-.023-.38.048-.528.173-.366.31-.46.805-.399 1.257.114.841.755 1.362 1.543 1.59 1.93.56 3.765-1.505 3.299-3.327M41.863 25.241c-1.413-.463-2.87-.746-4.346-.919-3.081-.36-6.243.017-9.198.946-5.708 1.796-10.808 5.52-14.26 10.367-.293.412.32.792.661.506 4.206-3.523 8.787-6.727 14.209-8.054 2.589-.633 5.27-.766 7.923-.52 1.29.12 2.568.398 3.802.786 1.345.422 2.625 1.302 3.992 1.585 1.501.31 2.45-1.352 1.46-2.491-1.007-1.16-2.819-1.74-4.243-2.206zM27.803 2.778c-3.61 1.614-7.116 3.577-10.49 5.631-3.269 1.99-6.197 4.334-8.543 7.366-2.367 3.058-4.17 6.5-5.943 9.918C1.82 27.636.938 29.613.5 31.765c-.47 2.307-.55 4.647-.345 6.984.044.507.874.717.97.13.315-1.915.452-3.846.76-5.762.319-1.98.943-3.83 1.831-5.629 1.58-3.203 3.28-6.418 5.314-9.361 4.262-6.166 11.025-9.761 17.613-13.04 1.879-.936 3.806-1.782 5.811-2.415 2.134-.675 4.248-.922 6.459-1.178.923-.107.958-1.388 0-1.454-3.761-.26-7.742 1.233-11.11 2.738zM78.075 16.937c-1.735-2.49-3.633-4.843-5.885-6.893-3.946-3.593-9.124-6.695-14.647-6.47-.322.013-.357.427-.073.535 4.912 1.88 9.298 4.597 12.903 8.435 1.849 1.968 3.518 4.125 5.031 6.355.803 1.182 1.566 2.392 2.304 3.615.66 1.094 1.345 2.886 2.541 3.462 1.016.489 2.058-.113 2.148-1.224.116-1.412-1.262-3.064-1.978-4.225-.75-1.216-1.526-2.417-2.344-3.59z",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(13.579 13.094) translate(.611 .79)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.579 13.094) translate(0 .184)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "a7dzmxwodd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mlwxslzz5c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#525D7D",
    d: "M.106 39.863C.959 17.619 19.53.137 41.41.019c28.805-.15 41.428 27.937 39.186 28.705-1.929.663-1.542-10.018-15.438-19.991C38.956-10.071 2.444 8.147 1.226 39.905c-.029.734-1.148.694-1.12-.042",
    mask: "url(#a7dzmxwodd)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A4C5F2",
    stroke: "#979797",
    strokeWidth: 0.5,
    d: "M39.296 33.421l21.139-9.357-14.48 15.777c-.086-2.702-.81-4.6-2.175-5.694-1.365-1.093-2.86-1.335-4.484-.726z",
    mask: "url(#a7dzmxwodd)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#525D7D",
    d: "M40.06 33.609c-4.594 0-7.134 5.315-3.895 8.733 2.998 3.162 8.182 1.423 8.909-2.793.553-3.11-1.87-5.883-5.013-5.94m-4.35.535c3.621-3.144 8.675-1.4 10.116 2.2 1.649 4.11-1.458 8.734-5.94 8.734-5.551 0-8.629-7.07-4.177-10.934z",
    transform: "translate(13.579 13.094) translate(0 .184)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525D7D",
    d: "M38.955 39.022c0 1.964 2.175 1.77 2.175.366 0-1.866-2.175-2.384-2.175-.366zm1.03 2.555c-2.593 0-2.901-4.328-.598-4.907 2.93-.746 4.333 4.907.599 4.907zM40.073 33.421c-.635 0-.777-.89-.173-1.085 14.596-4.72 21.193-10.114 21.775-8.507.22.609-.484.76-.818.893-.022.008-18.356 8.7-20.784 8.7",
    transform: "translate(13.579 13.094) translate(0 .184)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525D7D",
    d: "M60.65 24.206c.65-.824 1.495-.081.886.68-2.389 3.149-10.727 8.73-15.404 15.095-.11.149-.28.228-.453.228-3.94 0 13.185-13.65 14.97-16.003zM13.56 36.629c4.449-13.602 13.964-22.18 28.534-22.18 7.518 0 11.355 2.31 16.635 7.161.228.209.241.56.031.786-1.36 1.46-4.2-6.834-16.666-6.834-23.503 0-26.46 21.795-28 21.795-.379 0-.651-.367-.533-.728z",
    transform: "translate(13.579 13.094) translate(0 .184)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525D7D",
    d: "M14.366 37.357c-.441 0-.715-.492-.466-.864 13.941-20.843 36.743-11.06 33.406-8.69-1.357.964-.083-3.207-10.618-3.207-16.168 0-21.022 12.761-22.322 12.761M.556 39.503c3.983 0 4.169-.275 4.251.4.12.983-1.77.713-4.251.713-.74 0-.742-1.113 0-1.113zM6.244 25.552c-1.273-.577-2.039-.568-1.854-1.25.217-.8 1.273-.237 2.32.238.922.419 1.732.513 1.506 1.18-.238.71-1.054.249-1.972-.168M18.58 10.126c-.733-1.325-1.278-1.74-.715-2.15.683-.5 1.185.689 1.698 1.614.963 1.74 1.585 2.014 1.046 2.484-.708.617-1.502-.998-2.028-1.948M35.655 5.897c-.767 0-.897-1.688-.997-2.812-.114-1.293-.458-1.977.233-2.13.777-.172.782.882.883 2.033.168 1.89.903 2.91-.119 2.91M50.191 6.807c-.348 0-.612-.311-.552-.651.206-1.18.3-2.374.947-3.498.368-.638 1.341-.088.973.552-1.013 1.76-.372 3.597-1.368 3.597M64.702 11.966c.612-.6 1.289-1.116 1.906-1.653.557-.485 1.297.351.739.837-2.112 1.838-1.997 1.768-2.251 1.768-.497 0-.752-.602-.394-.952zM74.702 23.966c.612-.6 1.289-1.116 1.906-1.653.557-.485 1.297.351.739.837-2.112 1.838-1.997 1.768-2.251 1.768-.497 0-.752-.602-.394-.952z",
    transform: "translate(13.579 13.094) translate(0 .184)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.62 5.335) translate(.491 1.956)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "11c52ia9bf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#821yqsqhue"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E0DFE6",
    d: "M3.388.83C3.232.239 2.548-.034 1.993.01 1.557.046 1.166.199.845.509.77.584.71.674.631.747L.578.8C.579.796.574.795.498.848c-.535.378-.503 1.046 0 1.429.473.359 1.152.595 1.735.432.743-.208 1.363-1.084 1.155-1.88",
    mask: "url(#11c52ia9bf)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.62 5.335)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "eoh7r5yovh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8y41n41zcg"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#525D7D",
    d: "M1.594.918c-.652 0-1.488 1.941-.04 1.941 1.202 0 1.093-1.941.04-1.941m-.04 2.72c-2.482 0-1.628-3.5.04-3.5 2.08 0 2.166 3.5-.04 3.5",
    mask: "url(#eoh7r5yovh)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.462 58.68) translate(.974 2.437)"
  }, _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "97q6d5mg0j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#21nixis4li"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#E0DFE6",
    d: "M5.761 1.103C5.497.317 4.334-.045 3.39.015c-.742.047-1.408.25-1.953.662-.13.099-.231.219-.364.316-.063.046-.085.063-.09.069.002-.004-.007-.006-.135.065-.91.502-.857 1.39 0 1.899.803.477 1.958.791 2.95.574 1.263-.276 2.318-1.44 1.963-2.497",
    style: {
      mixBlendMode: "multiply"
    },
    mask: "url(#97q6d5mg0j)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.462 58.68)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "t4i3d1eg9l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4m7hpuqqtk"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#525D7D",
    d: "M2.197 1.085c-.899 0-2.051 2.704-.056 2.704 1.657 0 1.507-2.704.056-2.704m-.056 3.79C-1.279 4.874-.102 0 2.197 0c2.866 0 2.985 4.874-.056 4.874",
    mask: "url(#t4i3d1eg9l)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.549 25.703) translate(.491 1.663)"
  }, _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "2u0e39skan",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8xl91ge1em"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#E0DFE6",
    d: "M3.388.627C3.232.18 2.548-.026 1.993.008 1.557.035 1.166.15.845.385.77.441.71.509.631.565L.578.604C.579.6.574.6.498.64c-.535.285-.503.79 0 1.08.473.27 1.152.45 1.735.326.743-.157 1.363-.819 1.155-1.42",
    style: {
      mixBlendMode: "multiply"
    },
    mask: "url(#2u0e39skan)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.549 25.703)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "2t8qzzab5p",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#1mlzp51vio"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#525D7D",
    d: "M1.23.617C.727.617.082 2.154 1.2 2.154c.928 0 .844-1.537.031-1.537M1.2 2.77C-.716 2.771-.057 0 1.23 0 2.835 0 2.902 2.771 1.2 2.771",
    mask: "url(#2t8qzzab5p)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(98 47) translate(.491 1.663)"
  }, _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "9isida4n0r",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t96m0wff0q"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#E0DFE6",
    d: "M3.388.627C3.232.18 2.548-.026 1.993.008 1.557.035 1.166.15.845.385.77.441.71.509.631.565L.578.604C.579.6.574.6.498.64c-.535.285-.503.79 0 1.08.473.27 1.152.45 1.735.326.743-.157 1.363-.819 1.155-1.42",
    style: {
      mixBlendMode: "multiply"
    },
    mask: "url(#9isida4n0r)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(98 47)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ao9mgqo5vt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tjopveeqds"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#525D7D",
    d: "M1.23.617C.727.617.082 2.154 1.2 2.154c.928 0 .844-1.537.031-1.537M1.2 2.77C-.716 2.771-.057 0 1.23 0 2.835 0 2.902 2.771 1.2 2.771",
    mask: "url(#ao9mgqo5vt)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtDial);
export default __webpack_public_path__ + "static/media/art-dial.eb6de1f047b208dc7926349c5430aa7a.svg";
export { ForwardRef as ReactComponent };